module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-goto-8c7c4034ab55a4bcfdaf72503ee6295d.png";